import * as React from 'react';
import Progress from '../progress-bar/progress';
import styles from './value-bar.module.scss';

interface Props {
	value: number;
	total: number;
	strokeColor: string;
	valueType?: string;
	width?: number;
	className?: string;
}
const dangerColor = '#D93A17';
const ValueBar = ({ value, total, strokeColor, valueType, width, className }: Props) => {
	const isValueMoreThenTotal = value > total;
	return (
		<div data-test-id="value-bar">
			<Progress
				className={className}
				percent={(value / total) * 100}
				showInfo={false}
				type="line"
				strokeColor={isValueMoreThenTotal ? dangerColor : strokeColor}
				width={width}
			/>
			<div className={styles.valueBarDetails}>
				<span className={styles.valueBarDetailsValue} data-test-id="value">{`${value} ${
					valueType ?? ''
				}`}</span>
				<span className={styles.valueBarDetailsTotal} data-test-id="total-value">{`${total} ${
					valueType ?? ''
				}`}</span>
			</div>
		</div>
	);
};

export default ValueBar;
